module.exports = __webpack_public_path__ + "img/silvestre.47cb49e4.svg";